import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const HelpCenterCustomizeSidebar = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "help-center-customize-sidebar" */ './hocs'),
	),
});
